var messages = require('./datetime-strings');

var i18nConfig = {
    previousMonth: messages.previousMonth,
    nextMonth: messages.nextMonth,
    months: messages.fullMonths,
    weekdays: messages.fullDays,
    weekdaysShort : messages.mediumDays
};

module.exports = i18nConfig;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/pikaday-i18n.js
 **/